import React from 'react';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import KeyIcon from '@mui/icons-material/Key';
import DataObjectIcon from '@mui/icons-material/DataObject';
import ClassIcon from '@mui/icons-material/Class';
import HtmlIcon from '@mui/icons-material/Html';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import DifferenceIcon from '@mui/icons-material/Difference';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import LinkIcon from '@mui/icons-material/Link';
import TagIcon from '@mui/icons-material/Tag';
import CodeOffIcon from '@mui/icons-material/CodeOff';
import StorageIcon from '@mui/icons-material/Storage';
import TransformIcon from '@mui/icons-material/Transform';
import TableChartIcon from '@mui/icons-material/TableChart';
import ScheduleIcon from '@mui/icons-material/Schedule';
import PinIcon from '@mui/icons-material/Pin';
import PaletteIcon from '@mui/icons-material/Palette';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import BadgeIcon from '@mui/icons-material/Badge';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { CATEGORIES, TOOLS, ToolDefinition } from '../seo/seoData';

export interface Tool extends ToolDefinition {
  icon: React.ElementType;
  color: string;
}

const TOOL_VISUALS: Record<string, Pick<Tool, 'icon' | 'color'>> = {
  base64: { icon: SwapHorizIcon, color: '#64b5f6' },
  urlEncoder: { icon: LinkIcon, color: '#4fc3f7' },
  jwt: { icon: KeyIcon, color: '#f48fb1' },
  hashGenerator: { icon: TagIcon, color: '#9575cd' },
  htmlEntities: { icon: CodeOffIcon, color: '#ff8a65' },
  jsonBeautifier: { icon: DataObjectIcon, color: '#ffb74d' },
  sqlFormatter: { icon: StorageIcon, color: '#4db6ac' },
  xmlBeautifier: { icon: AccountTreeIcon, color: '#4dd0e1' },
  htmlBeautifier: { icon: HtmlIcon, color: '#ff8a65' },
  jsonToClass: { icon: ClassIcon, color: '#81c784' },
  jsonYaml: { icon: TransformIcon, color: '#ffd54f' },
  jsonCsv: { icon: TableChartIcon, color: '#66bb6a' },
  timestampConverter: { icon: ScheduleIcon, color: '#7986cb' },
  numberBaseConverter: { icon: PinIcon, color: '#a1887f' },
  colorConverter: { icon: PaletteIcon, color: '#f06292' },
  uuidGenerator: { icon: FingerprintIcon, color: '#64b5f6' },
  regexTester: { icon: ManageSearchIcon, color: '#ba68c8' },
  cronParser: { icon: EventRepeatIcon, color: '#4dd0e1' },
  textComparer: { icon: DifferenceIcon, color: '#b39ddb' },
  tcknVkn: { icon: BadgeIcon, color: '#e57373' },
  ibanValidator: { icon: AccountBalanceIcon, color: '#4db6ac' },
  xsltViewer: { icon: ReceiptLongIcon, color: '#aed581' },
};

export const tools: Tool[] = TOOLS.map((tool) => ({ ...tool, ...TOOL_VISUALS[tool.id] }));

export const toolCategories = CATEGORIES.map((category) => ({
  id: category,
  tools: tools.filter((tool) => tool.category === category),
}));
